import * as yup from 'yup';
export const beforeYouCancelSchema = yup.object().shape({
    cancelReason: yup.string().required('Please select a reason for canceling your plan'),
    freeTextCancelReason: yup.string().when('cancelReason', {
        is: 'Other (please specify)',
        then: yup.string().required('Please specify your reason for canceling'),
        otherwise: yup.string().notRequired(),
    }),
});
export const afterYouCancelSchema = yup.object().shape({
    accountName: yup.string().required('Please type your Main Account name'),
    userName: yup.string().required('Please type your account email address').email('Please enter a valid email address'),
});
//# sourceMappingURL=plan.schema.js.map